import React from 'react';

const MailHover = ({to, children}) => (
  <a href={`mailto:${to}`} className="mailto" data-to={to}>
    <span>{children}</span>
  </a>
)
export default MailHover;
